export const typeformValidationMethod = {
  updateValidationMethodUI() {
    const selectedMethod = this.selectedValidationMethod()

    if (this.hasSupportingDocumentsInputTarget) {
      const accept = selectedMethod === "screen_share_capture"
        ? this.lunaImageAccept()
        : this.lunaDocumentAccept()
      this.supportingDocumentsInputTarget.setAttribute("accept", accept)
    }

    if (this.hasValidationUploadHintTarget) {
      const path = selectedMethod === "screen_share_capture"
        ? "upload_hints.screen_share_capture"
        : "upload_hints.document_upload"
      const fallback = selectedMethod === "screen_share_capture"
        ? "Verification uses screen sharing only; useful matching screenshots are attached automatically as you capture the required details."
        : "JPEG · PNG · WebP · GIF · PDF · max 8 MB each"
      this.validationUploadHintTarget.textContent = this.t(path, fallback)
    }

    if (this.currentValue === 3) this.syncUploadStepVisibility()
  },

  lunaDocumentAccept() {
    return this.supportingDocumentsInputTarget.dataset.lunaDocumentAccept ||
      "image/jpeg,image/png,image/webp,image/gif,.jpg,.jpeg,.png,.webp,.gif,application/pdf,.pdf"
  },

  lunaImageAccept() {
    return this.supportingDocumentsInputTarget.dataset.lunaImageAccept ||
      "image/jpeg,image/png,image/webp,image/gif,.jpg,.jpeg,.png,.webp,.gif"
  },

  handleValidationMethodChange() {
    this.updateValidationMethodUI()
    if (this.currentValue === 2) this.next()
  },

  chooseValidationMethod(event) {
    const input = event.currentTarget.querySelector("input[name='status_match_application[validation_method]']")
    if (!input) return

    if (!input.checked) {
      input.checked = true
      input.dispatchEvent(new Event("change", { bubbles: true }))
    } else {
      this.updateValidationMethodUI()
      if (this.currentValue === 2) this.next()
    }
  },

  selectedValidationMethod() {
    return this.wizardForm()
      ?.querySelector("input[name='status_match_application[validation_method]']:checked")
      ?.value || null
  }
}
